export default __webpack_public_path__ + "static/media/btcIcon.5bb79634.svg";